import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const ProfessionalPlanningSection = ({
  user,
  onEditContinuityPlanning
}) => {
  const intl = useIntl();

  const formatContinuityState = (stateId) => {
    switch(stateId?.toString()) {
      case '1':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.continuity_none' });
      case '2':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.continuity_with_partner' });
      case '3':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.continuity_partner_only' });
      default:
        return intl.formatMessage({ id: 'succession.profile_edit.common.not_specified' });
    }
  };

  const formatSuccessionPlanningState = (stateId) => {
    switch(stateId?.toString()) {
      case '1':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.succession_none' });
      case '2':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.succession_complete' });
      case '3':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.succession_in_development' });
      default:
        return intl.formatMessage({ id: 'succession.profile_edit.common.not_specified' });
    }
  };

  const formatPlanningPreference = (pref) => {
    switch(pref) {
      case 'find_partner':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.planning_find_partner' });
      case 'become_partner':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.planning_become_partner' });
      case 'no_plan_preference':
        return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.planning_no_preference' });
      default:
        return intl.formatMessage({ id: 'succession.profile_edit.common.not_specified' });
    }
  };

  const formatTimeHorizon = (years) => {
    if (!years) return intl.formatMessage({ id: 'succession.profile_edit.common.not_specified' });
    if (years === 1) return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.time_horizon_one_year' });
    return intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.time_horizon_years' }, { years });
  };

  return (
    <div className="bg-succession-bg-secondary rounded-lg border border-succession-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-succession-text-primary">{intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.title' })}</h3>
        <button
          onClick={onEditContinuityPlanning}
          className="inline-flex items-center px-3 py-1.5 border border-succession-border rounded-lg text-sm text-succession-text-primary hover:bg-succession-bg-primary transition-colors"
        >
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          {intl.formatMessage({ id: 'succession.profile_edit.common.edit' })}
        </button>
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-succession-bg-primary rounded-lg p-4 border border-succession-border">
            <p className="text-xs text-succession-text-muted mb-2">{intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.business_continuity_readiness' })}</p>
            <p className="text-sm font-medium text-succession-text-primary">{formatContinuityState(user.business_continuity_state_id)}</p>
          </div>
          <div className="bg-succession-bg-primary rounded-lg p-4 border border-succession-border">
            <p className="text-xs text-succession-text-muted mb-2">{intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.succession_planning_readiness' })}</p>
            <p className="text-sm font-medium text-succession-text-primary">{formatSuccessionPlanningState(user.succession_planning_state_id)}</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-succession-bg-primary rounded-lg p-4 border border-succession-border">
            <p className="text-xs text-succession-text-muted mb-2">{intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.catastrophic_preference' })}</p>
            <p className="text-sm font-medium text-succession-text-primary">{formatPlanningPreference(user.planning_preference)}</p>
          </div>
          <div className="bg-succession-bg-primary rounded-lg p-4 border border-succession-border">
            <p className="text-xs text-succession-text-muted mb-2">{intl.formatMessage({ id: 'succession.profile_edit.sections.professional_planning.planning_time_horizon' })}</p>
            <p className="text-sm font-medium text-succession-text-primary">{formatTimeHorizon(user.target_timeframe)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

ProfessionalPlanningSection.propTypes = {
  user: PropTypes.object.isRequired,
  onEditContinuityPlanning: PropTypes.func.isRequired,
};

export default ProfessionalPlanningSection;
